import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Categories from "./components/Categories";
import Special from "./components/Special";
import Voices from "./components/Voices";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { feedItems } from "@/mocks/data";

function Ticker() {
  const doubled = [...feedItems, ...feedItems];
  return (
    <div className="relative w-full overflow-hidden border-y border-background-200 bg-accent-500 py-3">
      <div className="flex w-max items-center marquee-track">
        {doubled.map((it, i) => (
          <a
            key={`${it.id}-${i}`}
            href="#feed"
            className="inline-flex items-center gap-2 whitespace-nowrap px-6 text-sm font-semibold text-foreground-950"
          >
            <i className="ri-flashlight-fill text-base" />
            {it.title}
            <span className="font-normal opacity-70">·</span>
          </a>
        ))}
      </div>
    </div>
  );
}

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Feed />
        <Categories />
        <Special />
        <Voices />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}